<template lang="pug">
.cc-cms
  router-view
  //- MessageBox(
  //-   :active='msgBox.active'
  //-   :showType='msgBox.type'
  //-   :showContent='msgBox.content')

</template>

<script>
// import axiosInstance from '@/axios/index'
// import axios from "axios";
// import MessageBox from './components/MessageBox/MessageBox.vue'

export default {
  // components:{ MessageBox },

  created() {
    // this.initServiceWorkerProcess(122, 'vendor');
    if (!this.loginProfile) { return; }
    // if (!this.loginProfile.auth_id || !this.loginProfile.team_id) { return; }
    
    // this.$OneSignal.sendTags({
    //   type: 'vendor',
    //   aid: `${this.loginProfile.auth_id}`,
    //   tid: `${this.loginProfile.team_id}`,
    // });
  },

  // methods: {
  //   urlB64ToUint8Array(base64String) {
  //     const padding = '='.repeat((4 - base64String.length % 4) % 4);
  //     const base64 = (base64String + padding)
  //       .replace(/\-/g, '+')
  //       .replace(/_/g, '/');

  //     const rawData = window.atob(base64);
  //     const outputArray = new Uint8Array(rawData.length);
  //     const outputData = outputArray.map((output, index) => rawData.charCodeAt(index));
  //     return outputData;
  //   },

  //   initServiceWorkerProcess(authId, userType) {
  //     const registerWebPush = async () => {
  //       if ('serviceWorker' in navigator) {
  //         const reg = await navigator.serviceWorker.register(`${this.BASE_URL}wp/sw.js`);
  //         initWebPushSubscription(reg);
  //       } else {
  //         alert('ServiceWorker UnSupported!');	
  //       }
  //     };

  //     const initWebPushSubscription = async (reg) => {
  //       const subscription = await reg.pushManager.getSubscription();

  //       if (subscription) {
  //         detectSubConfig(subscription);
  //         return;
  //       }

  //       const vapidMeta = document.querySelector('meta[name="vapid-key"]');
  //       const key = vapidMeta.content;
  //       const options = {
  //         userVisibleOnly: true,
  //         // if key exists, create applicationServerKey property
  //         ...(key && { applicationServerKey: this.urlB64ToUint8Array(key) })
  //       };
  //       const sub = await reg.pushManager.subscribe(options);
  //       detectSubConfig(sub);
  //     };

  //     const detectSubConfig = async (subscription) => {
  //       const browser = navigator.userAgent.match(/(firefox|msie|chrome|safari|trident)/ig)[0].toLowerCase();
  //       const data = {
  //         status_type: 'subscribe',
  //         subscription: subscription.toJSON(),
  //         browser: browser,
  //         id: authId,
  //         group: userType,
  //       };

  //       await axios.post(`${this.SERVER_DOMAIN}/apiserver/save_webpushinfo`, JSON.stringify(data), {
  //         headers: {
  //           'content-type': 'application/json'
  //         },
  //         credentials: 'include'
  //       });
  //     };

  //     registerWebPush();
  //   },
  // }
}

</script>

<style lang="scss">
@import 'css/main';

body {
  background: #161616;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
  background: #161616;
}
</style>
